module.exports = __webpack_public_path__ + "/images/ico-nav-user-circle.abf894f.svg";